/* eslint-disable @typescript-eslint/dot-notation */
import { TinyMceService } from 'src/app/services/tinyMce.service';
import { ContentService } from 'src/app/services/content.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-galleries-make-edit',
  templateUrl: './galleries-make-edit.page.html',
  styleUrls: ['./galleries-make-edit.page.scss'],
})
export class GalleriesMakeEditPage implements OnInit {

  updateGalleryForm: FormGroup;

  tinyMCEConfiguration;

  id: string;
  galleryId: string;
  oldGalleryId: string;
  file=new FormControl('');
  fileData: FormData;
  fileUploaded = false;

  url: any;
  extension: any;
  pageTitle: string;

  constructor(
    private fb: FormBuilder,
    private contentService: ContentService,
    private router: Router,
    private tinyMCE: TinyMceService,
    private actRoute: ActivatedRoute,
    public http: HttpClient,
    private cdRef: ChangeDetectorRef,
    public authService: AuthenticationService,
  ) {
    this.tinyMCEConfiguration = this.tinyMCE.tinyMCEConfiguration;
   }

  ngOnInit() {
    this.authService.login();
    this.id = this.actRoute.snapshot.paramMap.get('id');
    this.galleryId = this.actRoute.snapshot.paramMap.get('galleryId');
    this.onGetPage(this.id);
    this.updateGalleryForm = this.fb.group({
      created: [''],
      filename: [''],
      order: [''],
      content: [''],
      page:[this.id],
    });

    this.contentService.getSingleGallery(this.id, this.galleryId).subscribe(res => {
      const a = res.payload.data();
      // console.log(a);
      this.url = '/gallery/' + this.id + '/' + this.galleryId + '.' + a['filename'];
      this.oldGalleryId = a['filename'];
      // console.log('oldgalleryext: ' + this.oldGalleryId);
      this.updateGalleryForm.patchValue(a);
    });
  }

  ionViewWillEnter() {
    if (this.authService.isLoggedIn === false) {
      this.router.navigateByUrl('/admin/login');
    }
  }

  onGetPage(id: string) {
    this.contentService.getPage(id).subscribe(res => {
      const a = res.payload.data();
      // console.log(a["published"]);
      this.pageTitle = a['title'];
    });
  }

  updateGallery() {
    const changes = this.updateGalleryForm.value;
    // console.log(changes);
    const update = this.contentService.updateSingleGallery(this.id, this.galleryId, changes)
    .subscribe();
    console.log('potato before uploaded!');
    if (this.fileUploaded === true) {
      console.log('potato uploaded!');
      this.uploadFile(this.galleryId);
    }
    update.unsubscribe();
    console.log(this.id);
    this.router.navigateByUrl(`/admin/galleries-edit/${this.id}`);

  }

  fileChange(event) {
    const fileList: FileList = event.target.files;
    //check whether file is selected or not
    if (fileList.length > 0) {
      this.fileUploaded = true;
        const file = fileList[0];
        //get file information such as name, size and type
        // console.log('finfo',file.name,file.size,file.type);
        // console.log(file);
        this.extension = file.name.split('.').pop();
        this.updateGalleryForm.controls.filename.setValue(file ? this.extension : '');
        //max file size is 4 mb
        if((file.size/1048576)<=2)
        {
          const formData = new FormData();
          const info={id:2,name:'raja'};
          formData.append('file', file, file.name);
          // formData.append('id','2');
          formData.append('tz',new Date().toISOString());
          formData.append('update','2');
          formData.append('info',JSON.stringify(info));
          formData.append('id',this.id);
          this.fileData=formData;
          // console.log('calling upload');
          // this.uploadFile();
          // Todo: Do the edit gallery item next and the delete button
        }else{
          //this.snackBar.open('File size exceeds 4 MB. Please choose less than 4 MB','',{duration: 2000});
        }
    }
    const reader = new FileReader();
    reader.readAsDataURL(fileList[0]);
    reader.onload = (_event) => {
      this.url = reader.result;
    };
  }

  uploadFile(galleryId: string) {
    // console.log('upload called');
    this.fileData.append('galleryId', galleryId);
    this.fileData.append('oldGalleryId', galleryId + '.' + this.oldGalleryId);
    // console.log('filedata');
    // console.log(this.fileData);
    this.http.post('upload-gallery.php',this.fileData)
    .subscribe(res => {
      // console.log(res);
    }, (err) => {
    //send error response
    });
    // this.url = null;
    // this.url = 'gallery/' + this.id + '.' + this.extension;
    // this.cdRef.detectChanges();
    // console.log(this.url);
  }
}
